import React, {useEffect, useMemo, useState} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import TagSelect from '../../../TagSelect';
import {companyActions} from '../../../../state/actions/company.actions';
import {tagFamilyConstants} from '../../../../constants';
import {formHelpers, objectHelpers} from '../../../../utils/helpers';

const CompanyTagSelect = ({
  addTags,
  getTags,
  costCenterTags,
  expenseTags,
  locationTags,
  projectTags,
  teamTags,
  vendorsTags,
  isAdmin,
  isEnableAdd = true,
  optionValueName = 'tag_name',
  selected = [],
  tagFamily = tagFamilyConstants.COST_CENTER,
  ...rest
}) => {

  const [tagOptions, setTagOptions] = useState([]);

  const getTagFamilyOptions = () => {
    const optionsList = {
      [tagFamilyConstants.COST_CENTER]: costCenterTags,
      [tagFamilyConstants.EXPENSE]: expenseTags,
      [tagFamilyConstants.LOCATION]: locationTags,
      [tagFamilyConstants.PROJECT]: projectTags,
      [tagFamilyConstants.TEAM]: teamTags,
      [tagFamilyConstants.VENDORS]: vendorsTags,
    };
    return optionsList[tagFamily] ?? [];
  };

  useEffect(() => {
    let options = getTagFamilyOptions();

    if (options.length !== tagOptions.length) {
      options = formHelpers.getTagOptions(options, optionValueName);
      setTagOptions(options);
    }
  }, [costCenterTags, expenseTags, locationTags, projectTags, teamTags, vendorsTags, tagFamily]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const tagFamilyOptions = formHelpers.getTagOptions(getTagFamilyOptions(), optionValueName);

    // Filter out selected values that are not in the existing tagOptions
    const missedOptions = selected
      .filter(value => !tagFamilyOptions.some(option => option.value === value))
      .map(value => ({ label: value, value }));

    const newTagOptions = [...tagFamilyOptions, ...missedOptions];

    if (!objectHelpers.arraysIsEqual(tagOptions, newTagOptions)) {
      setTagOptions(newTagOptions);
    }
  }, [selected]); // eslint-disable-line react-hooks/exhaustive-deps

  const isEnableAddButton = useMemo(() => isEnableAdd && isAdmin, [isEnableAdd, isAdmin]);

  const handleAddNewTag = (value) => {
    if (isAdmin) {
      addTags({
        data: {
          tags: [{tag_name: value, tag_family: tagFamily}]
        },
        successCallback: getTags
      });
    }
  }

  return (
    <TagSelect
      {...rest}
      onAdd={handleAddNewTag}
      options={tagOptions}
      isEnableAdd={isEnableAddButton}
      selected={selected}
    />
  );
}

CompanyTagSelect.propTypes = {
  isEnableAdd: PropTypes.bool,
  optionValueName: PropTypes.oneOf(['id', 'tag_name']),
  selected: PropTypes.array,
  tagFamily: PropTypes.oneOf(Object.values(tagFamilyConstants))
}

const mapDispatchToProps = {
  addTags: companyActions.addTags,
  getTags: companyActions.getTags
}

const mapStateToProps = state => {
  const {costCenterTags, expenseTags, locationTags, projectTags, teamTags, vendorsTags} = state.company;
  let {isAdmin} = state.user;
  return {
    costCenterTags,
    expenseTags,
    locationTags,
    projectTags,
    teamTags,
    vendorsTags,
    isAdmin,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CompanyTagSelect);
